// Abonent modulining kesh kalitlari.
//
// NEGA BIR JOYDA (`features/cashdesk/cashdeskKeys.ts` bilan AYNAN bir xil
// sabab): keshni bekor qilish PREFIKS bo'yicha ishlaydi. Kalit chaqiruv
// joyida qo'lda yozilsa, biri `['subscribers']`, ikkinchisi `['subs']`
// deb yozadi va bekor qilish JIMGINA ishlamay qoladi — ekranda esa
// bloklangan abonent hali ham «Faol» bo'lib turadi.
//
// ⚠️ NEGA KASSA KALITLARIGA QO'SHILMADI: prefikslar ATAYLAB ayri.
// Amaldan keyin bitta prefiks bekor qilinadi, ya'ni umumiy prefiks
// abonentni bloklaganda kassirning depozit so'rovini ham qayta
// yurgizardi — foydasiz so'rov, va u aynan telefonda, sekin tarmoqda
// to'lanadi. `features/*` bir-birini import qilmaydi (07-FRONTEND.md §6),
// shuning uchun to'qnashuv ham bo'lishi mumkin emas.

/** Ro'yxat so'rovining kalitga tushadigan qismi */
export interface SubscriberListKey {
  search: string
  state: string | null
  page: number
  size: number
}

export const subscriberKeys = {
  all: ['subscribers'] as const,
  /** ⚠️ Filtr va sahifa KALITDA — usiz oldingi sahifaning qatorlari ekranda qolardi */
  list: (key: SubscriberListKey) =>
    ['subscribers', 'list', key.search, key.state ?? '', key.page, key.size] as const,
  /** Kartochkaning bir so'rovli manzarasi: balans, tezlik, sessiya */
  overview: (id: string) => ['subscribers', 'overview', id] as const,
  /** Amaldagi paketlar — `overview` DAN ALOHIDA: ikki endpoint, ikki huquq yo'li */
  grants: (id: string) => ['subscribers', 'grants', id] as const,
  /** Sotiladigan paketlar katalogi — kamdan-kam o'zgaradi */
  plans: ['subscribers', 'plans'] as const,
  /** Abonent filialida sotilmaydigan paketlar (ADR-047) */
  deniedPlans: (branchId: string | null) => ['subscribers', 'deniedPlans', branchId] as const,
  /**
   * Abonentning kontakti (`xsib-platform`).
   *
   * ⚠️ `overview` DAN ALOHIDA: boshqa servis, boshqa huquq va u
   * YETMASLIGI mumkin. Umumiy kalitda bo'lsa kontakt 403 bilan qaytgan
   * kuni kartochkaning butun manzarasi ham «xato» bo'lib qolardi.
   */
  contact: (id: string) => ['subscribers', 'contact', id] as const,
  /**
   * MIJOZ KABINETI parolining holati (`xsib-selfcare`).
   *
   * ⚠️ Prefiks `subscribers` — `useSubscriberAction` amaldan keyin
   * aynan shu prefiksni bekor qiladi, ya'ni parol o'rnatilgach holat
   * («o'rnatilmagan» → «oxirgi marta …») O'ZI yangilanadi. Alohida
   * prefiks yozilsa oynadagi holat eski qolib ketardi va operator
   * amal bajarilmadi deb o'ylardi.
   */
  selfcarePassword: (id: string) => ['subscribers', 'selfcarePassword', id] as const,
} as const
